export default __webpack_public_path__ + "static/media/sameroom.706643d9.svg";